"use client";

import { trpcApi } from "@lattice/frontend/lib/trpc/client/index";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { trpcClientArgs } from "@lattice/frontend/lib/trpc/client/vanillaClient";
import { z } from "zod";

const z_TRPCError = z.object({
  data: z.object({ httpStatus: z.number() }),
});

export function TRPCProvider({ children }: React.PropsWithChildren) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Never cache errors — always allow refetch after failure
            retry: (failureCount, error) => {
              const parsed = z_TRPCError.safeParse(error);
              if (parsed.success) {
                const { httpStatus } = parsed.data.data;
                if (httpStatus >= 400 && httpStatus < 500) return false;
              }
              return failureCount < 2;
            },
          },
        },
      }),
  );
  const [trpcClient] = useState(() => trpcApi.createClient(trpcClientArgs));

  return (
    <trpcApi.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        {children}
      </QueryClientProvider>
    </trpcApi.Provider>
  );
}
